import React, { useState, useEffect } from 'react';
import { osName } from 'react-device-detect';
import FloatingWhatsApp from 'react-floating-whatsapp'

import LandingSection from '../components/LandingSection';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import BrandSection from '../components/BrandSection';
import ServiceSection from '../components/ServiceSection';
import PortfolioSection from '../components/PortfolioSection';
import { sectionObjOne } from '../components/ServiceSection/Data';
import { portfolioObjOne } from '../components/PortfolioSection/Data';
import PartnersSection from '../components/PartnersSection';
import { partnersObjOne } from '../components/PartnersSection/Data';
import AboutSection from '../components/AboutSection';
import { aboutObjOne } from '../components/AboutSection/Data';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';



const Home = () => {

    const [isOpen, setIsOpen] = useState(false);
    const [isLandscape, setisLandscape] = useState(false);
    const [fixLandscape, setfixLandscape] = useState(false)
    const [Screen, setScreen] = useState();
    const [scrollNav, setScrollNav] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    const changeNav = () => {
        if (window.scrollY > 110) {
            setScrollNav(true);
        } if (window.scrollY < 90) {
            setScrollNav(false);
        }
    }

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            window.addEventListener('scroll', changeNav)
        }
        return () => isSubscribed = false;
    }, [])

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            window.addEventListener("orientationchange", function() {
                // `this` is now pointing to `window`, not the component. So use `self`.
                setScreenOrientation(this.screen.height, this.screen.width);
                
            }, false);
        }
        return () => isSubscribed = false;
    }, [])


    const setScreenOrientation = (height, width) => {
        if(width > height){
            setfixLandscape(true);
            
            if(width > 767){
                setisLandscape(true);
            }else{
                setisLandscape(false);
            }
        }else{
            setisLandscape(false);
            setfixLandscape(false);

        }

        setScreen({height: height, width: width});
      }
    

    return (
        <>
        <div style={styles.cover}>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} isScroll={scrollNav} />
            <LandingSection isLandscape={isLandscape} fixLandscape={fixLandscape}/>
            <BrandSection/>
            <ServiceSection {...sectionObjOne}/>
            <PortfolioSection />
            <PartnersSection {...partnersObjOne}/>
            <AboutSection {...aboutObjOne}/>
            <ContactSection/>
            <Footer/>
            <FloatingWhatsApp 
                className={scrollNav? 'whatsAppIcon':'whatsAppIconHide'}
                accountName='Sucursal Tijuana' 
                phoneNumber='+526641700338' 
                styles={{right: '125px',zIndex:3}}
                zIndex='3' />
            <FloatingWhatsApp 
                className={scrollNav? 'whatsAppIcon':'whatsAppIconHide'}
                accountName='Sucursal Irapuato' 
                phoneNumber='+524621159283' 
                styles={{zIndex:3}}
                zIndex='3' />
        </div>
        </>
    
    )
}



const styles = {
    cover: {
        width: '100%',
    },
    whatsappWindow:{
        width: '500px !important'
    }
}
export default Home
